export default {
      id: "refeer__wind-usage",
      viewBox: "0 0 37 31",
      url: __webpack_public_path__ + "img/icons.svg#refeer__wind",
      toString: function () {
        return this.url;
      }
    }